// Word / Character Counter Tool — live text statistics + keyword density.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const wordCounterTool: Tool = {
  id: "word-counter",
  name: () => m.wc_tool_name(),
  description: () => m.wc_tool_description(),
  icon: "🔤",
  basePath: "/word-counter",
  status: "stable",
  tags: ["text", "words", "characters", "writing"],
  pages: [
    {
      name: () => m.wc_nav_main(),
      path: "/word-counter",
      description: () => m.wc_nav_main_desc(),
      icon: "🔤",
    },
  ],
};
